import { createApp } from 'vue';
import { Fancybox } from '@fancyapps/ui/dist/fancybox/';
import BasketStep1App from './modules/basket-step1/BasketStep1App.vue';
import BasketStep2App from './modules/basket-step2/BasketStep2App.vue';
import './styles/main.scss';

const appRegistry = {
  'basket-step1': BasketStep1App,
  'basket-step2': BasketStep2App
};

function getProps(dataset) {
  return Object.entries(dataset).reduce((props, [key, value]) => {
    if (key === 'vueApp') {
      return props;
    }

    props[key] = value;
    return props;
  }, {});
}

document.querySelectorAll('[data-vue-app]').forEach((element) => {
  const appName = element.dataset.vueApp;
  const rootComponent = appRegistry[appName];

  if (!rootComponent) {
    return;
  }

  createApp(rootComponent, getProps(element.dataset)).mount(element);
});

Fancybox.bind('.fancy', {
  groupAll: true
});
